<app-game [allowFlip]="true" [widthPart]="0.95" [heightPart]="0.8" [aspectRatio]="board.cols/board.rows">
  <div *ngIf="wasInited">
    <app-gengine-client *ngIf="options.remote"
                        [client]="client" [game]="multi"></app-gengine-client>
    <app-tools [board]="board" ></app-tools>
    <app-board [options]="options" [board]="board">
    </app-board>
    <app-options [options]="options"
                 (loaded)="onOptionsLoaded()"
                 (changed)="onOptionsChange()"></app-options>
    <app-levels [width]="game.gameWidth" [levels]="board.levels"></app-levels>
  </div>
</app-game>
